import basicHandRanking from '../../../assets/basic-hand-ranking.png'
import advancedHandRanking from '../../../assets/advanced-hand-ranking.png'
import lingo from '../../../assets/lingo.png'
import raiseOrFold1 from '../../../assets/raise-or-fold1.png'
import raiseOrFold2 from '../../../assets/raise-or-fold2.png'
import war from '../../../assets/war.png'

export const miniGames = [
  {
    id: 1,
    title: 'Basic Hand Ranking',
    img: basicHandRanking,
    params: {
      gameName: 'basic-hand-ranking'
    }
  },
  {
    id: 2,
    title: 'Advanced Hand Ranking',
    img: advancedHandRanking,
    params: {
      gameName: 'advanced-hand-ranking'
    }
  },
  {
    id: 3,
    title: 'Lingo',
    img: lingo,
    params: {
      gameName: 'lingo'
    }
  },
  {
    id: 4,
    title: 'War',
    img: war,
    params: {
      gameName: 'war'
    }
  },
  {
    id: 5,
    title: 'Raise Or Fold 1',
    img: raiseOrFold1,
    params: {
      gameName: 'raise-or-fold-1'
    }
  },
  {
    id: 6,
    title: 'Raise Or Fold 2',
    img: raiseOrFold2,
    params: {
      gameName: 'raise-or-fold-2'
    }
  }
]
